var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-warn"},[_vm._m(0),_c('warn-table')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-title"},[_c('span',[_vm._v("监控参数配置")])])}]

export { render, staticRenderFns }